
import {defineComponent} from 'vue'
import {cnkCodesArrayIsValid, convertProductCodesListToArray} from "@/helpers/functions/products";
import {DpException} from "@/exception/DpException";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";

export default defineComponent({
  name: "InputProductList",
  components: {InputTextEditor},
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array,
      required: true,
      default: [] as string[],
    },
    errors: {
      type: Object,
      required: true,
    },
    fieldLabel: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 300,
    },
    useProductCodes: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      internalModel: '<p>' + this.modelValue.join(', ') + '</p>',
    };
  },
  watch: {
    modelValue: function (newVal) {
      this.internalModel = '<p>' + newVal.join(', ') + '</p>';
    },
  },
  methods: {
    onBlur() {
      const result = convertProductCodesListToArray(this.internalModel);
      if (!this.useProductCodes && !cnkCodesArrayIsValid(result)) {
        throw [new DpException(this.$t('exceptionOnlyNumbersCnk'))];
      }
      this.$emit('update:modelValue', result);
    },
  },
});
